// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/components/DispatchKPISection.js
// =============================================================================

import React from "react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function DispatchKPISection({

  kpis = {}

}) {

  const cards = [

    {
      label: "Draft Dispatches",
      value: kpis.draft || 0,
      color: "#2563eb",
      icon: "📦"
    },

    {
      label: "Submitted",
      value: kpis.submitted || 0,
      color: "#16a34a",
      icon: "🚚"
    },

    {
      label: "Approved",
      value: kpis.approved || 0,
      color: "#0891b2",
      icon: "✔"
    },

    {
      label: "Total Boxes",
      value: kpis.totalBoxes || 0,
      color: "#ea580c",
      icon: "📋"
    },

    {
      label: "Total Weight",
      value: kpis.totalWeight || 0,
      color: "#dc2626",
      icon: "⚖"
    }
  ];

  return (

    <div style={styles.grid}>

      {cards.map((card) => (

        <div
          key={card.label}
          style={{
            ...styles.card,
            borderTop:
              `4px solid ${card.color}`
          }}
        >

          <div>

            <div style={styles.label}>
              {card.label}
            </div>

            <div style={styles.value}>
              {card.value}
            </div>

          </div>

          <div style={styles.icon}>
            {card.icon}
          </div>

        </div>

      ))}

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  grid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(220px, 1fr))",

    gap: 16,

    marginBottom: 20
  },

  card: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 18,

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  label: {

    fontSize: 13,

    color: "#6b7280",

    marginBottom: 8
  },

  value: {

    fontSize: 30,

    fontWeight: 700,

    color: "#111827"
  },

  icon: {

    fontSize: 26
  }
};